import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureCardDefaultComponent } from './feature-card-default.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [FeatureCardDefaultComponent],
  exports: [FeatureCardDefaultComponent]
})
export class FeatureCardDefaultModule {}
